(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["decade-intro-accordion"]) return;
  try {
    
    const accordion = document.getElementsByClassName('accordion-button');

    for (i=0; i<accordion.length; i++) {
      accordion[i].addEventListener('click', function () {
        this.classList.toggle('open')
      })
    }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-josh"]) return;
  try {
    
        const dropdown = document.getElementsByClassName('dropdown-toggle__container');

        for (i=0; i<dropdown.length; i++) {
          dropdown[i].addEventListener('click', function () {
            this.classList.toggle('open')
          })
        }
    
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["help-center--purchasing-and-ordering"]) return;
  try {
    
    const accordion = document.getElementsByClassName('accordion-arrow');

    for (i=0; i<accordion.length; i++) {
      accordion[i].addEventListener('click', function () {
        this.classList.toggle('open')
      })
    }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["help-center--returns-and-exchanges"]) return;
  try {
    
    const accordion = document.getElementsByClassName('accordion-arrow');

    for (i=0; i<accordion.length; i++) {
      accordion[i].addEventListener('click', function () {
        this.classList.toggle('open')
      })
    }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["help-center--security-and-privacy"]) return;
  try {
    
    const accordion = document.getElementsByClassName('accordion-arrow');

    for (i=0; i<accordion.length; i++) {
      accordion[i].addEventListener('click', function () {
        this.classList.toggle('open')
      })
    }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["help-center--shipping-and-delivery"]) return;
  try {
    
    const accordion = document.getElementsByClassName('accordion-arrow');

    for (i=0; i<accordion.length; i++) {
      accordion[i].addEventListener('click', function () {
        this.classList.toggle('open')
      })
    }

  } catch(e) { console.error(e); }
})();
})();
